<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        group: {
            type: Object,
            required: true
        },

        search: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            users: [],
            page: 1,
            perPage: 12,
            total: 0
        };
    },

    computed: {
        ...mapGetters({
            selectedCampus: 'campuses/selectedCampus'
        })
    },

    watch: {
        search() {
            this.onSearchInput();
        },

        selectedCampus() {
            this.fetchGroup();
        }
    },

    async mounted() {
        await this.fetchGroup();
    },

    methods: {
        ...mapActions({
            getGroup: 'aboutUs/show'
        }),

        async fetchGroup(getMore = false) {
            try {
                this.page = getMore ? this.page + 1 : 1;

                const { rows: users, count } = await this.getGroup({
                    id: this.group.id,
                    search: this.search,
                    page: this.page,
                    perPage: this.perPage
                });

                this.total = count;
                this.users = getMore ? [...this.users, ...users] : users;
            } catch (err) {
                console.error(err);

                this.$toasted.global.error();
            }
        },

        onSearchInput() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }

            this.timer = setTimeout(() => {
                this.fetchGroup();
            }, 500);
        },

        onContactUs(email) {
            this.$emit('contact-us', email);
        }
    }
};
</script>
